<template>
  <div class="">
  <vue-headful
	title="Settings - Select Currency"
	description="Select your preferred currency."
  />
  <div id="breadcrumb" class="m-1">
  <b-breadcrumb >
  	<b-breadcrumb-item text="Home" />
  	<b-breadcrumb-item text="Settings" />
  	<b-breadcrumb-item text="Currency" active/>
  </b-breadcrumb>
  </div>

    <h1>Select Currency</h1>

    <p class="lead">
    Select your preferred fiat currency.
    </p>


	<b-row align-h="center" >
		<b-col>
			<h3 ><b-button variant="primary" ref="currencyButton" @click="showCurrencyItems()"><b-badge variant="dark"><span v-html="getCurrencySymbol()"></span></b-badge> {{ getCurrencyName() }}</b-button></h3>
		    <!-- <b-form-input id="currency-selection" type="text" placeholder="Your currency" ref="currencySelection" :value="selectedCurrency"></b-form-input> -->
			<form-filterlist v-bind:item-factory="getCurrencyItems" v-bind:item-display="displayCurrencyItem" v-bind:item-selected="selectCurrencyItem" ref="currencyItems"></form-filterlist>
		</b-col>
	</b-row>


  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>

<script>
import FormFilterlist from '@/components/FormFilterlist';

export default {
  name: '',
  components: {'form-filterlist': FormFilterlist},
  data () {
    return {
      loadingSpinner: true,
//      selectedCurrency: null,
      currencyItems: [],

    }
  },

  computed: {

		currencyList: function() {

			//return require('@/assets/data/currencylist.json');
			return require('@/assets/data/currencySymbols.json');
		},

		selectedCurrency: function() {
			return this.$root.$store.getters['CCStore/myCurrency'];
		},
  },

  mounted: function () {

//	    if (this.currencyList) {
//	    	this.currencyItems = Object.keys(this.currencyList).sort();
//	    }

		this.$nextTick(function () {
			// Code that will run only after the
			// entire view has been rendered

//			// restore last profit/loss settings
//			var profitAmount = this.rememberData('profitAmount') || 0;
//			this.$set(this.profitLoss, 'profitAmount', profitAmount);


//			this.initializeData();


		});
	},

  methods: {

	  showCurrencyItems() {

		  if (this.$refs.currencyItems) {
			  this.$refs.currencyItems.showItems();
		  }

	  },

	  getCurrencyItems() {
		  var itemList = [];
		  for (var item in this.currencyList) {
//			  itemList.push({"name": this.currencyList[item].Name, "value":item});
			  itemList.push({"name": this.currencyList[item].FullName, "value":item, "htmlCode": this.getHtmlCode(this.currencyList[item]) });
		  }
		  return itemList;
	  },

	  displayCurrencyItem(item) {
		  return item.name + " (" + item.value + ")";
	  },

	  selectCurrencyItem(item) {
		  //this.selectedCurrency = item.value;
		  return this.$root.$store.commit('CCStore/updateMyCurrency', item.value); // save state
		  this.selectedCurrencySymbol = this.getHtmlCode(item.value);
	  },

	  getCurrencyName() {
		  if ((this.currencyList[this.selectedCurrency]) && (this.currencyList[this.selectedCurrency].FullName)) {
			  return this.currencyList[this.selectedCurrency].FullName;
		  }
	  },

	  getCurrencySymbol() {
		  if (this.currencyList[this.selectedCurrency]) {
			  return this.getHtmlCode(this.currencyList[this.selectedCurrency]);
		  }
	  },

	  getHtmlCode(currency) {
		  var htmlCode = "$"; //default to dollar sign
		  var chars;
		  var counter;

		  var currencyRecord;

		  if (typeof currency == "object") {
			  currencyRecord = currency;

		  } else {
			  if (this.currencyList[currency]) {
				  currencyRecord = this.currencyList[currency];
			  }
		  }

		  if ((currencyRecord) && (currencyRecord.UnicodeHex)) {
			  // Some currencies use multiple characters separated by comma
			  chars = currencyRecord.UnicodeDecimal.split(',');
			  htmlCode = "";
			  for (counter = 0; counter < chars.length; counter++ ) {
				  // convert to HTML unicode hex entities
				  htmlCode += "&#"+ chars[counter] + ";";
			  }
		  }

		  return htmlCode;
	  },

//	  initializeData() {
//		  var promisedData = this.getExchangeList();
//		  promisedData.then((exchanges) =>{
//			  this.exchanges = exchanges; // save entire object
//
//			  // build an array of exchange names
//			  for (var exchange in exchanges) {
//				  this.exchangeList.push(exchange);
//			  }
//
//			  this.exchangeList.sort();
//
//			  // Remove loading spinner
//			  this.loadingSpinner = false;
//		  });
//	  }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/SettingsCurrency.vue